import { WikiLayout } from "@/components/WikiLayout";
import { WikiPage } from "@/components/WikiPage";

const ProfileDashboard = () => {
  return (
    <WikiLayout>
      <WikiPage 
        title="My Dashboard" 
        description="Your personal performance and stats"
      >
        <section className="space-y-6">
          <div className="bg-muted/50 border border-border rounded-lg p-6">
            <p className="text-center text-muted-foreground italic">
              📊 Personal dashboard coming soon! This will show your stats, earnings, and performance metrics.
            </p>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">What You'll See Here</h2>
          <div className="space-y-4">
            <div className="border border-border rounded-lg p-4">
              <h3 className="text-lg font-medium mb-2">Earnings Overview</h3>
              <ul className="list-disc list-inside space-y-1 text-muted-foreground ml-4">
                <li>Current pay period earnings</li>
                <li>Month-to-date totals</li>
                <li>Year-to-date earnings</li>
                <li>Commission and bonus breakdown</li>
              </ul>
            </div>

            <div className="border border-border rounded-lg p-4">
              <h3 className="text-lg font-medium mb-2">Performance Metrics</h3>
              <ul className="list-disc list-inside space-y-1 text-muted-foreground ml-4">
                <li>Customer satisfaction rating</li>
                <li>Average stops per day</li>
                <li>Route efficiency score</li>
                <li>Safety record</li>
              </ul>
            </div>

            <div className="border border-border rounded-lg p-4">
              <h3 className="text-lg font-medium mb-2">Route Information</h3>
              <ul className="list-disc list-inside space-y-1 text-muted-foreground ml-4">
                <li>Total assigned customers</li>
                <li>Upcoming schedule</li>
                <li>Recent service history</li>
                <li>Customer notes and preferences</li>
              </ul>
            </div>

            <div className="border border-border rounded-lg p-4">
              <h3 className="text-lg font-medium mb-2">Goals & Bonuses</h3>
              <ul className="list-disc list-inside space-y-1 text-muted-foreground ml-4">
                <li>Progress toward bonus thresholds</li>
                <li>Retention rate tracking</li>
                <li>Review count and ratings</li>
                <li>Safety days without incident</li>
              </ul>
            </div>

            <div className="border border-border rounded-lg p-4">
              <h3 className="text-lg font-medium mb-2">Time Off & Schedule</h3>
              <ul className="list-disc list-inside space-y-1 text-muted-foreground ml-4">
                <li>PTO balance</li>
                <li>Upcoming time off requests</li>
                <li>Schedule changes</li>
                <li>Holiday calendar</li>
              </ul>
            </div>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Coming Soon Features</h2>
          <ul className="list-disc list-inside space-y-2 text-muted-foreground">
            <li>Mobile app integration with real-time updates</li>
            <li>Detailed earnings calculator</li>
            <li>Customer feedback dashboard</li>
            <li>Training progress tracker</li>
            <li>Document upload and storage</li>
            <li>Direct messaging with office</li>
          </ul>

          <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mt-8">
            <p className="text-sm">
              <strong>💡 In the meantime...</strong> Contact the office for any stats, reports, or information 
              about your performance at (619) 555-0100 or info@bluelux.com
            </p>
          </div>
        </section>
      </WikiPage>
    </WikiLayout>
  );
};

export default ProfileDashboard;